<template>
    <div class="installt">
        <div class="intext">商铺信息列表</div>
        <div class="addpoper" @click="openDialog">
            <div> <el-icon :size="24" color="#fff">
                    <Plus style=" margin-right: 8px" />
                </el-icon></div>
            <div style="height: 24px;">添加商铺</div>
        </div>
    </div>
    <div class="shops">
        <div class="shopslei">
            <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
                <el-tab-pane :label="'助花商铺（' + totallists + '家）'" name="first">
                    <ShopsList @totallist='totallist'></ShopsList>
                </el-tab-pane>
                <el-tab-pane label="待审核商铺" name="second">
                    <Auditshops></Auditshops>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
    <yc-mask ref="maskRef" :close-on-click-modal="false">
        <div class="dialog">
            <div class="dialogt">
                <div>
                    添加商铺
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>

            <div class="search">
                <div style="margin-right: 14px;">
                    <!-- <img src="" alt=""> -->
                    <el-icon>
                        <Search />
                    </el-icon>
                </div>
                <div>
                    <input v-model="addstorekey" type="text" placeholder="输入id或关键词" @keyup.enter="addstore">
                </div>
            </div>
            <div class="nextgroom">
                <div class="rooms" v-for="(item, index) in addstorelist" :key="index">
                    <div class="userh">
                        <div class="userhs">
                            <!-- <img src="@/asseets/shop/morentx.png" alt=""> -->
                            <img src="../../assets/shop/morentx.png" alt="">
                        </div>
                        <div class="username">
                            <div>{{ item.username }}</div>
                            <div class="memng">门铃号：{{ item.userId }}</div>
                        </div>
                    </div>
                    <div class="norooms" @click="addstoerid(item.userId)" :style="{'pointer-events':item.isOpened?'none':'auto'}">
                        {{ isopenStore(item) }}
                        <!-- 开通店铺 -->
                    </div>
                </div>
            </div>
        </div>
    </yc-mask>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ShopsList from '@/components/ShopsList.vue';
import Auditshops from '@/components/Auditshops.vue';
import ycMask from '@/components/mask/mask.vue'
import { ElMessage } from 'element-plus'
import storeapi from '@/api/store'
let addstorekey = ref('')
let addstorelist = ref([])
onMounted(() => {

});
const totallists = ref(0)
const totallist = (value) => {
    totallists.value = value
}
//添加搜索
const addstore = async () => {
    try {
        let data = {
            "keyword": addstorekey.value,
            "keywordType": 1
        }
        const res = await storeapi.StoreAddkey(data)
        console.log('添加搜索', res)
        addstorelist.value = res.data.records
    } catch {

    }
}
//店铺开通
const addstoerid = async (storeid) => {
    try {
        let data = {
            userId: storeid
        }
        const res = await storeapi.openStore(storeid)
        console.log(res)
        if (res.success) {
            ElMessage({
                message: '店铺开通成功！',
                type: 'success',
            })
        } else {
            ElMessage.error('店铺开通失败！' + res.message)
        }

    } catch {

    }
}

const isopenStore = (Store) => {
    console.log(Store)
    if (Store.isOpened) {
        return '店铺已开通'
    } else {
        return '开通店铺'
    }
}
//获取遮罩的实例
let maskRef = ref(null);
//打开弹窗
let openDialog = () => {
    maskRef.value.showMask();
};

//关闭弹窗
let closeDialog = () => {
    maskRef.value.closeMask();
};
const activeName = ref('first')

const handleClick = (tab, event) => {

}
</script>

<style lang="scss" scoped>
::v-deep .demo-tabs {

    height: 100%;

    .el-tabs__header {
        margin-bottom: 0;
    }

    .el-tabs__nav-scroll {

        .el-tabs__nav {

            .el-tabs__item {
                height: 60px !important;
                margin-right: 61px;
            }
        }
    }

    .el-tabs__content {
        height: calc(100% - 60px);
    }

    #tab-first {
        margin-left: 24px !important;
    }
}

.installt {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 32px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpoper {
        width: 132px;
        height: 48px;
        background: rgba(63, 140, 255);
        box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
        border-radius: 8px;
        color: #FFFFFF;
        cursor: pointer;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }
}

.shops {
    position: relative;
    margin-top: 25px;
    height: calc(100% - 85px);
    min-width: 1166px;
    // min-height: 662px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;

    .shopslei {
        height: 100%;
    }
}

.dialog {
    position: relative;
    width: 380px;
    height: 608px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 23px 36px 0 35px;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 20px;
    }



    .search {
        width: 100%;
        height: 48px;
        margin-right: 24px;
        background: #F8F8F8;
        box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin: 14px auto;
        padding-left: 20px;
        box-sizing: border-box;

        input {
            width: 300px;
            border: none;
            outline: none;
            font-size: 16px;
            background: #F8F8F8;

        }

    }

    .nextgroom {
        height: 440px;
        overflow: auto;

        .rooms {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;


            .userh {
                display: flex;
                width: 334px;


                .userhs {
                    width: 56px;
                    height: 56px;
                    border-radius: 28px;
                    background-color: #d4d0d0;
                    margin-right: 10px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .username {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    font-size: 17px;

                    .memng {
                        font-size: 14px;
                        font-weight: 400;
                        color: #4D585F;
                        width: 100%;
                    }
                }
            }

            .norooms {
                width: 102px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                border-radius: 8px;
                border: 1px solid #0291FE;
                font-size: 16px;
                font-weight: 400;
                color: #0091FF;
                cursor: pointer;
            }
        }
    }


}
</style>